export default "__VITE_ASSET__l44Z6q0r__"